/** ລາຄາຂາຍແພັກເກດກຸ່ມ — flatPrice ແມ່ແບບ = ລາຄາຕໍ່ຄົນ, ຄູນດ້ວຍຈຳນວນສະມາຊິກຕອນຂາຍ */
export function computeGroupPackageOriginalPrice(
  flatPricePerPerson: number,
  groupSize: number,
): number {
  if (groupSize < 1) return 0;
  return flatPricePerPerson * groupSize;
}

export function applyGroupPackageSellDiscount(
  originalPrice: number,
  discountType?: "percentage" | "fixed",
  discountValue?: number,
): {
  originalPrice: number;
  discountAmount: number;
  finalPrice: number;
} {
  let discountAmount = 0;
  let finalPrice = originalPrice;

  if (discountType && discountValue !== undefined) {
    if (discountType === "percentage") {
      discountAmount = Math.round((originalPrice * discountValue) / 100);
    } else if (discountType === "fixed") {
      discountAmount = Math.round(discountValue);
    }
    discountAmount = Math.min(discountAmount, originalPrice);
    finalPrice = originalPrice - discountAmount;
    if (finalPrice < 0) {
      finalPrice = 0;
      discountAmount = originalPrice;
    }
  }

  return { originalPrice, discountAmount, finalPrice };
}
